export const ITEM_TYPE = {
  LOTTERY: 'LOTTERY',
  G3: 'G3',
  G5: 'G5',
  G10: 'G10',
  L2D10: 'L2D10',
}

export const BOX_PICKER_NAME = {
  JIDRID: 'จิ๊ดริด',
  SORNRAM: 'ศรราม',
  NOT: 'นอท',
  SUNAREE: 'สุนารี',
  MONSIT: 'มนต์สิทธิ์',
  HAI: 'ฮาย',
  JENNY: 'เจนนี่',
  JACK: 'แจ็ค',
  JACK_THE_GHOST: 'พี่แจ็ค เดอะโกสท์',
  TUKKY: 'ตุ๊กกี้',
}

export const ORDER_ITEM_TYPE = {
  LOTTERY: 'LOTTERY',
  BOX: 'BOX',
}

export const getOrderItemType = (type) => {
  switch (type) {
    case ITEM_TYPE.G3:
    case ITEM_TYPE.G5:
    case ITEM_TYPE.G10:
    case ITEM_TYPE.L2D10:
      return ORDER_ITEM_TYPE.BOX
    case ITEM_TYPE.LOTTERY:
    default:
      return ORDER_ITEM_TYPE.LOTTERY
  }
}

export const MYSTERY_BOX_ITEM = {
  G3: {
    name: 'เลขชุด',
    count: 3,
    color: 'red',
  },
  G5: {
    name: 'เลขชุด',
    count: 5,
    color: 'red',
  },
  G10: {
    name: 'เลขชุด',
    count: 10,
    color: 'red',
  },
  L2D10: {
    name: 'เลขท้าย',
    count: 10,
    color: '#FFD700',
  },
}
